export enum Experiment {
  UseNewPostsCoverDefaults = 'specs.membersAbout.UseNewPostsCoverDefaults',
  EnableAboutContainerStyles = 'specs.membersAbout.EnableAboutContainerStyles',
  EnableHtmlTagSettings = 'specs.membersAbout.EnableHtmlTagSettings',
}
